import React from 'react';
import { Dialog, DialogContent } from './ui/dialog';
import { X, FileText } from 'lucide-react';

export default function InfoModal({ content, open, onClose }) {
  if (!content) return null;
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[var(--panel)] border-[var(--border)] text-[var(--text)] max-w-lg p-0 gap-0 [&>button]:hidden max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between p-6 border-b border-[var(--border)]">
          <div className="flex items-center gap-2.5">
            <FileText size={18} className="text-[var(--orange)]" />
            <div>
              <h3 className="font-display font-semibold text-white text-[16px] leading-tight">{content.title}</h3>
              {content.tag && <span className="text-[9px] font-mono tracking-widest text-[var(--muted-2)]">{content.tag}</span>}
            </div>
          </div>
          <button onClick={onClose} className="text-[var(--muted)] hover:text-white p-1"><X size={18} /></button>
        </div>
        <div className="p-6 space-y-4">
          {content.body.map((sec, i) => (
            <div key={i}>
              {sec.h && <h4 className="text-[10px] font-mono tracking-[0.14em] text-[var(--orange)] mb-1.5">{sec.h.toUpperCase()}</h4>}
              <p className="text-[13.5px] text-[var(--muted)] leading-relaxed">{sec.p}</p>
            </div>
          ))}
          <p className="text-center text-[10px] font-mono text-[var(--muted-2)] pt-2 border-t border-[var(--border)]">ALL DATA SIMULATED FOR DEMONSTRATION · NOT AN OFFER TO BUY OR SELL SECURITIES</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
